import { useState } from "react";
import { Redirect, useParams } from "react-router-dom";
import { useFirebase, useFirestore, useFirestoreConnect } from 'react-redux-firebase'
import { useSelector } from "react-redux";
import { v4 as uuidv4 } from 'uuid';

import Page from './Page';
//import LinkButton from '../components/LinkButton';
import PodcastForm from '../components/PodcastForm';
import Loading from '../components/Loading';

const PodcastCreate = () => {
  const { userId } = useParams();
  const [isLoading, setIsLoading ] = useState(false);
  const [savedPodcastId, setSavedPodcastId] = useState();
  const users = useSelector(state => state.firestore?.data?.users)
  const firestore = useFirestore();
  const firebase = useFirebase();

  useFirestoreConnect([
    {
      collection: 'users',
    }
  ])

  const onSave = async (formData) => {
    setIsLoading(true);

    // Get submission & file
    const submission = { ...formData };
    const file = submission.contentFile && submission.contentFile.length === 1 && submission.contentFile[0];
    delete submission.contentFile;

    // Generate an id
    const id = uuidv4();

    // Upload file
    if (file) {
      const fileRef = firebase.storage().ref().child('submissions').child(id);
      const fileSnapshot = await fileRef.put(file);
      submission.contentFileUrl = await fileSnapshot.ref.getDownloadURL();
    }

    // Populate auth details
    submission['userId'] = userId;

    // Add submission to firestore
    await firestore.collection('submissions').doc(id).set(submission);

    setSavedPodcastId(id);
    setIsLoading(false);
  }

  const userName = users && userId in users && (users[userId].companyName || users[userId].name);
  const breadcrumbs = [
    {title: "Podcasts", link: "/podcasts"},
    {title: userName, link: `/podcasts/by-user/${userId}`},
    {title: "New Podcast", link: ""}
  ]

  if(!isLoading && savedPodcastId) {
    return <Redirect to={`/podcasts/details/${savedPodcastId}`} />
  }

  return (
    <Page action={<></>} breadcrumbs={breadcrumbs}>
      <div className="row">
        <div className="col-12">
          <div className="card">
            { isLoading ? <Loading /> : <PodcastForm podcast={{}} onSave={onSave} />}
          </div>
        </div>
      </div>
    </Page>
  )
}

export default PodcastCreate;
